<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Ava Mae is a newly graduated student with her bachelor’s in social work; however, her passion lies in writing. She believes books are the bridge to the imagination and can take one across the world without leaving the comfort of their chair. She enjoys outdoor activities and nature. Most of all, she enjoys educating herself on the individual lives of others and their experiences.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?6f162a02